import { render, staticRenderFns } from "./seguro-empate-activated.vue?vue&type=template&id=ed811490&scoped=true&"
import script from "./seguro-empate-activated.vue?vue&type=script&lang=js&"
export * from "./seguro-empate-activated.vue?vue&type=script&lang=js&"
import style0 from "./seguro-empate-activated.vue?vue&type=style&index=0&id=ed811490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed811490",
  null
  
)

export default component.exports